let config = {
  emailjs: {
    serviceID: "service_r5u6snw",
    templateID: "template_6oasnzw",
    userID: "user_fxyN8mKE398WWvl5ZKykI"
  }
};

export default config;
